import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, FileText } from 'lucide-react';

export const MobileActionBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Hide on quote page step 2+ to not interfere
  const hideOnPaths = ['/admin', '/dashboard', '/quote'];
  const shouldHide = hideOnPaths.some(path => location.pathname.startsWith(path));

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  if (shouldHide) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      {/* Gradient fade effect */}
      <div className="absolute -top-8 left-0 right-0 h-8 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      
      <div className="bg-background border-t border-border px-2 py-2 safe-area-pb">
        <div className="flex items-center justify-around gap-1">
          {/* Call Button */}
          <a
            href="tel:07300405045"
            className="flex-1 flex flex-col items-center gap-1 py-2 px-3 rounded-xl bg-primary text-primary-foreground active:scale-95 transition-transform"
            data-testid="mobile-call-btn"
          >
            <Phone className="w-5 h-5" />
            <span className="text-xs font-medium">Call</span>
          </a>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/447300405045?text=Hi%2C%20I%20need%20a%20quote%20for%20a%20job"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex flex-col items-center gap-1 py-2 px-3 rounded-xl bg-green-500 text-white active:scale-95 transition-transform"
            data-testid="mobile-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" />
            <span className="text-xs font-medium">WhatsApp</span>
          </a>

          {/* Quote Button */}
          <button
            onClick={() => navigate('/quote')}
            className="flex-1 flex flex-col items-center gap-1 py-2 px-3 rounded-xl bg-gradient-to-r from-lime-500 to-green-500 text-white active:scale-95 transition-transform"
            data-testid="mobile-quote-btn"
          >
            <FileText className="w-5 h-5" />
            <span className="text-xs font-medium">Free Quote</span>
          </button>
        </div>
      </div>
    </div>
  );
};
